import styled from "styled-components";
import css from "@styled-system/css";
import { desktop, mobile } from "../../theme";

export const Title = styled("div")(
  css({
    fontSize: [3, 4],
    fontWeight: "bold",
    mb: 30,
  })
);

export const Description = styled("p")(
  css({
    fontSize: [2, 3],
    my: 0,
  })
);

export const Image = styled("img")(
  css({
    display: "block",
    mx: "auto",
    mb: 30,
  })
);

export const ImageAdaptive = styled(Image)(
  css({
    [desktop]: {
      ml: 0,
      mt: -110,
      mb: 5,
    },
  })
);

export const Header = styled("div")(
  css({
    img: {
      display: "block",
    },
    h4: {
      fontSize: [2, 3],
      m: 0,
    },
    [mobile]: {
      mb: 30,
      img: {
        width: 140,
        mb: 36,
      },
    },
    [desktop]: {
      display: "flex",
      alignItems: "center",
      mb: 40,
      img: {
        width: 80,
        marginRight: 36,
      },
    },
  })
);

export const Card = styled("div")({
  boxSizing: "border-box",
  padding: 30,
  background: "#fff",
  borderRadius: "30px",
});
